import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import GenericDetails from '../../common/GenericDetails';
import ChemicalProductDetailsForm from './ChemicalProductDetailsForm';
import getChemicalProductDetailsFormSchema from '../../../formSchemas/ChemicalProductDetailsFormSchema';
import { chemicalProductsActions } from '../../../behavior/chemicalProducts/index';
import { CLONE_MODE, CREATE_MODE, EDIT_MODE, entityType } from '../../../constants';
import { manipulateValuesBeforeSubmission } from '../../../utils';
import useUser from '@behavior/init/getUserV2';

const ChemicalProductDetailsFormContainer = ({
  save,
  mode,
  isLoading,
  initialData,
  getInitialData,
  chemicalProduct,
  getChemicalProduct,
  deleteChemicalProduct,
  id,
  processedNotificationBody,
  recipients,
  i18n,
  markAsChecked,
}) => {
  const { user } = useUser();

  useEffect(() => {
    getInitialData(mode == CREATE_MODE || mode == CLONE_MODE, mode == CLONE_MODE);
    if (id) getChemicalProduct(id, mode == CLONE_MODE);
  }, []);

  let initialValues = chemicalProduct ? { chemicalProduct: chemicalProduct } : null;
  const submitHandle = (values, actions) => {
    save(
      manipulateValuesBeforeSubmission(
        values,
        processedNotificationBody,
        recipients,
        user,
        i18n,
        markAsChecked
      ),
      mode
    );
    actions.setSubmitting(false);
  };

  return (
    <GenericDetails
      initialValues={initialValues}
      validationSchema={getChemicalProductDetailsFormSchema()}
      validateOnChange={mode === CREATE_MODE || CLONE_MODE || EDIT_MODE}
      initialData={initialData}
      save={save}
      mode={mode}
      isLoading={isLoading}
      isHistory={false}
      id={id}
      deleteHandler={deleteChemicalProduct}
      entityTypeProp={entityType.product}
      updateUser={initialValues ? initialValues.chemicalProduct.updateUser : null}
      renderContainer={props => <ChemicalProductDetailsForm {...props} isHistory={false} />}
      submitHandle={submitHandle}
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...state.chemicalProducts,
  mode: ownProps.match.params.mode,
  id: ownProps.match.params.id,
  processedNotificationBody: state.changesNotificationModal.processedChangesNotification,
  recipients: state.changesNotificationModal.recipients,
  markAsChecked: state.changesNotificationModal.markAsChecked,
});

const mapDispatchToProps = dispatch => ({
  getInitialData: (isCreateMode, isCloneMode) =>
    dispatch(chemicalProductsActions.getInitialData(isCreateMode, isCloneMode)),
  getChemicalProduct: (id, isCloneMode) =>
    dispatch(chemicalProductsActions.getChemicalProduct(id, isCloneMode)),
  getNewChemicalProduct: () => dispatch(chemicalProductsActions.getNewChemicalProduct()),
  save: saveDto => dispatch(chemicalProductsActions.saveChemicalProduct(saveDto)),
  deleteChemicalProduct: id => dispatch(chemicalProductsActions.deleteChemicalProduct(id, true)),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ChemicalProductDetailsFormContainer);
